import React from "react";
import ililce from "../../helpers/ililce";

class RegisteredAddressForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      city: "",
      town: "",
      phone: "",
      address: "",
      postal_code: "",
      // Kayıtlı kullanıcılar için ek alanlar
      saveAddress: false, // Adresi kaydetmek istiyor mu?
      address_name: "", // Adres adı (ev, iş, vs.)
      // Fatura bilgileri
      invoice_type: "individual", // individual veya corporate
      company_name: "",
      tax_number: "",
      tax_office: "",
      errors: {},
    };
    // formPrefix kullanarak unique name'ler oluştur
    this.formPrefix = this.props.formPrefix || "";
  }

  componentDidMount() {
    // Eğer props'tan initial data gelmişse state'i güncelle
    if (this.props.initialData) {
      this.setState({
        ...this.state,
        ...this.props.initialData,
        errors: {}, // Hataları sıfırla
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Props değiştiğinde (düzenle butonuna basıldığında) state'i güncelle
    if (
      this.props.initialData &&
      this.props.initialData !== prevProps.initialData
    ) {
      this.setState({
        ...this.state,
        ...this.props.initialData,
        errors: {},
      });
    }
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    // formPrefix varsa name'den çıkar
    let fieldName = name;
    if (this.formPrefix && name.startsWith(this.formPrefix)) {
      fieldName = name.substring(this.formPrefix.length);
    }

    // Telefon için özel işlem - sadece rakamları al
    if (fieldName === "phone" && type !== "checkbox") {
      newValue = value.replace(/\D/g, "");
      // Maximum 10 hane
      if (newValue.length > 10) {
        newValue = newValue.substring(0, 10);
      }
    }

    // Vergi numarası için özel işlem - sadece rakamları al
    if (fieldName === "tax_number" && type !== "checkbox") {
      newValue = value.replace(/\D/g, "");
      // Maximum 11 hane (VKN: 10, TCKN: 11)
      if (newValue.length > 11) {
        newValue = newValue.substring(0, 11);
      }
    }

    this.setState(
      {
        [fieldName]: newValue,
      },
      function () {
        // Parent component'e güncellemeyi bildir
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      }.bind(this)
    );
  };

  handleCityChange = (e) => {
    this.setState(
      {
        city: e.target.value,
        town: "", // Şehir değişince ilçeyi sıfırla
      },
      function () {
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      }.bind(this)
    );
  };

  validate = () => {
    const errors = {};
    const {
      first_name,
      last_name,
      city,
      town,
      phone,
      address,
      saveAddress,
      address_name,
      invoice_type,
      company_name,
      tax_number,
      tax_office,
    } = this.state;

    // Teslimat bilgileri
    if (!first_name || first_name.trim() === "")
      errors.first_name = "Ad zorunludur";
    if (!last_name || last_name.trim() === "")
      errors.last_name = "Soyad zorunludur";
    if (!city) errors.city = "Şehir seçiniz";
    if (!town) errors.town = "İlçe seçiniz";

    // Telefon validasyonu - 10 haneli, başında sıfır yok
    if (!phone) {
      errors.phone = "Telefon numarası giriniz";
    } else if (phone.length !== 10) {
      errors.phone = "Telefon numarası 10 haneli olmalıdır";
    } else if (phone.charAt(0) === "0") {
      errors.phone = "Telefon numarası 0 ile başlamamalıdır";
    }

    if (!address || address.trim() === "") errors.address = "Adres giriniz";

    // Adres başlığı - Düzenleme modunda veya saveAddress seçiliyse zorunlu
    if (this.props.isEditMode || saveAddress) {
      if (!address_name || address_name.trim() === "") {
        errors.address_name = "Adres başlığı giriniz (Örn: Ev, İş, Diğer)";
      }
    }

    // Kurumsal fatura validasyonu
    if (invoice_type === "corporate") {
      if (!company_name || company_name.trim() === "") {
        errors.company_name = "Firma adı zorunludur";
      }
      if (!tax_number || tax_number.trim() === "") {
        errors.tax_number = "Vergi numarası zorunludur";
      } else if (!/^\d+$/.test(tax_number.trim())) {
        errors.tax_number = "Vergi numarası sadece rakamlardan oluşmalıdır";
      } else if (tax_number.trim().length < 10) {
        errors.tax_number = "Vergi numarası en az 10 haneli olmalıdır";
      }
      if (!tax_office || tax_office.trim() === "") {
        errors.tax_office = "Vergi dairesi zorunludur";
      }
    }

    this.setState({ errors: errors });
    return Object.keys(errors).length === 0;
  };

  getData = () => {
    if (this.validate()) {
      // State'deki tüm verileri döndür (saveAddress checkbox durumu dahil)
      return {
        ...this.state,
      };
    }
    return null;
  };

  render() {
    const {
      first_name,
      last_name,
      city,
      town,
      phone,
      address,
      postal_code,
      saveAddress,
      address_name,
      invoice_type,
      company_name,
      tax_number,
      tax_office,
      errors,
    } = this.state;

    const cities = ililce.map(function (item) {
      return item.il;
    });
    const towns =
      city &&
      ililce.find(function (item) {
        return item.il === city;
      })
        ? ililce.find(function (item) {
            return item.il === city;
          }).ilceleri
        : [];

    return (
      <div>
        {/* Adres Başlığı - Sadece düzenleme modunda en üstte */}
        {this.props.isEditMode && (
          <div className="form-group">
            <label style={styles.label}>
              Adres Başlığı <span style={styles.required}>*</span>
            </label>
            <input
              type="text"
              name="address_name"
              value={address_name}
              onChange={this.handleChange}
              className={
                "form-control " + (errors.address_name ? "is-invalid" : "")
              }
              placeholder="Örn: Ev, İş, Diğer"
            />
            {errors.address_name && (
              <div className="invalid-feedback">{errors.address_name}</div>
            )}
          </div>
        )}

        {/* Ad / Soyad */}
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label style={styles.label}>
                Ad <span style={styles.required}>*</span>
              </label>
              <input
                type="text"
                name="first_name"
                value={first_name}
                onChange={this.handleChange}
                className={
                  "form-control " + (errors.first_name ? "is-invalid" : "")
                }
                placeholder="Adınız"
              />
              {errors.first_name && (
                <div className="invalid-feedback">{errors.first_name}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label style={styles.label}>
                Soyad <span style={styles.required}>*</span>
              </label>
              <input
                type="text"
                name="last_name"
                value={last_name}
                onChange={this.handleChange}
                className={
                  "form-control " + (errors.last_name ? "is-invalid" : "")
                }
                placeholder="Soyadınız"
              />
              {errors.last_name && (
                <div className="invalid-feedback">{errors.last_name}</div>
              )}
            </div>
          </div>
        </div>

        {/* Şehir / İlçe */}
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label style={styles.label}>
                Şehir <span style={styles.required}>*</span>
              </label>
              <select
                name="city"
                value={city}
                onChange={this.handleCityChange}
                className={"form-control " + (errors.city ? "is-invalid" : "")}
              >
                <option value="">Şehir Seçiniz</option>
                {cities.map(function (c, i) {
                  return (
                    <option key={i} value={c}>
                      {c}
                    </option>
                  );
                })}
              </select>
              {errors.city && (
                <div className="invalid-feedback">{errors.city}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label style={styles.label}>
                İlçe <span style={styles.required}>*</span>
              </label>
              <select
                name="town"
                value={town}
                onChange={this.handleChange}
                className={"form-control " + (errors.town ? "is-invalid" : "")}
                disabled={!city}
              >
                <option value="">İlçe Seçiniz</option>
                {towns.map(function (t, i) {
                  return (
                    <option key={i} value={t}>
                      {t}
                    </option>
                  );
                })}
              </select>
              {errors.town && (
                <div className="invalid-feedback">{errors.town}</div>
              )}
            </div>
          </div>
        </div>

        {/* Telefon */}
        <div className="form-group">
          <label style={styles.label}>
            Telefon <span style={styles.required}>*</span>
          </label>
          <input
            type="tel"
            name="phone"
            value={phone}
            onChange={this.handleChange}
            className={"form-control " + (errors.phone ? "is-invalid" : "")}
            placeholder="5XX XXX XX XX (10 haneli, başında sıfır olmadan)"
          />
          {errors.phone && (
            <div className="invalid-feedback">{errors.phone}</div>
          )}
          <small className="form-text text-muted">
            Telefon numaranızı başında sıfır olmadan 10 haneli olarak giriniz
            (örn: 5321234567)
          </small>
        </div>

        {/* Adres */}
        <div className="form-group">
          <label style={styles.label}>
            Adres <span style={styles.required}>*</span>
          </label>
          <textarea
            name="address"
            value={address}
            onChange={this.handleChange}
            className={"form-control " + (errors.address ? "is-invalid" : "")}
            rows="3"
            placeholder="Mahalle, sokak, bina no, daire no vb."
          ></textarea>
          {errors.address && (
            <div className="invalid-feedback">{errors.address}</div>
          )}
        </div>

        {/* Kurumsal Fatura Checkbox */}
        <div className="form-group">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id={this.formPrefix + "corporateInvoice"}
              name={this.formPrefix + "invoice_type"}
              checked={invoice_type === "corporate"}
              onChange={function (e) {
                this.setState(
                  {
                    invoice_type: e.target.checked ? "corporate" : "individual",
                  },
                  function () {
                    // Parent component'e güncellemeyi bildir
                    if (this.props.onChange) {
                      this.props.onChange(this.state);
                    }
                  }.bind(this)
                );
              }.bind(this)}
            />
            <label
              className="custom-control-label"
              htmlFor={this.formPrefix + "corporateInvoice"}
              style={styles.checkboxLabel}
            >
              Kurumsal fatura girmek istiyorum
            </label>
          </div>
        </div>

        {/* Kurumsal Fatura Alanları - Sadece checkbox seçiliyse göster */}
        {invoice_type === "corporate" && (
          <div>
            {/* Firma Adı */}
            <div className="form-group">
              <label style={styles.label}>
                Firma Adı <span style={styles.required}>*</span>
              </label>
              <input
                type="text"
                name="company_name"
                value={company_name}
                onChange={this.handleChange}
                className={
                  "form-control " + (errors.company_name ? "is-invalid" : "")
                }
                placeholder="Firma adınızı giriniz"
              />
              {errors.company_name && (
                <div className="invalid-feedback">{errors.company_name}</div>
              )}
            </div>

            {/* Vergi No / Vergi Dairesi */}
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label style={styles.label}>
                    Vergi No <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="tax_number"
                    value={tax_number}
                    onChange={this.handleChange}
                    className={
                      "form-control " + (errors.tax_number ? "is-invalid" : "")
                    }
                    placeholder="Örn: 8790032867 (sadece rakam)"
                  />
                  {errors.tax_number && (
                    <div className="invalid-feedback">{errors.tax_number}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label style={styles.label}>
                    Vergi Dairesi <span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    name="tax_office"
                    value={tax_office}
                    onChange={this.handleChange}
                    className={
                      "form-control " + (errors.tax_office ? "is-invalid" : "")
                    }
                    placeholder="Vergi daireniz"
                  />
                  {errors.tax_office && (
                    <div className="invalid-feedback">{errors.tax_office}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Adresi Kaydet Checkbox - Sadece yeni adres eklerken göster */}
        {!this.props.isEditMode && (
          <React.Fragment>
            <div className="form-group">
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={this.formPrefix + "saveAddress"}
                  name={this.formPrefix + "saveAddress"}
                  checked={saveAddress}
                  onChange={this.handleChange}
                />
                <label
                  className="custom-control-label"
                  htmlFor={this.formPrefix + "saveAddress"}
                  style={styles.checkboxLabel}
                >
                  Bir sonraki işlem için bu adresi kaydet
                </label>
              </div>
            </div>

            {/* Adres Başlığı - Sadece checkbox seçiliyse göster */}
            {saveAddress && (
              <div className="form-group">
                <label style={styles.label}>
                  Adres Başlığı <span style={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  name="address_name"
                  value={address_name}
                  onChange={this.handleChange}
                  className={
                    "form-control " + (errors.address_name ? "is-invalid" : "")
                  }
                  placeholder="Örn: Ev, İş, Diğer"
                />
                {errors.address_name && (
                  <div className="invalid-feedback">{errors.address_name}</div>
                )}
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const styles = {
  sectionTitle: {
    paddingBottom: "16px",
    color: "#272727",
    flex: "1 1 auto",
    fontSize: "20px",
    lineHeight: "32px",
    letterSpacing: "normal",
    fontWeight: "normal",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#4c566a",
    marginBottom: "6px",
  },
  required: {
    color: "#dc3545",
  },
  divider: {
    margin: "28px 0",
    border: 0,
    borderTop: "1px solid #e6eaf2",
  },
  checkboxLabel: {
    fontSize: "15px",
    fontWeight: "500",
    color: "#272727",
  },
};

export default RegisteredAddressForm;



// WEBPACK FOOTER //
// ./src/components/AddressStep/RegisteredAddressForm.js